import { Button, DatePicker, Form, Modal } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';

interface QuoteValidUntilFormValues {
  validUntil: Dayjs;
}

interface JobQuoteValidUntilModalProps {
  open: boolean;
  jobNumber: string;
  submitting: boolean;
  onCancel: () => void;
  onSubmit: (validUntil: string) => Promise<void>;
}

/** Quoting is a small form, not a bare click (gitaumoses4/chukua#34): the one date the quote stays valid until — a future day, since a quote expired on arrival is pointless. */
export function JobQuoteValidUntilModal({ open, jobNumber, submitting, onCancel, onSubmit }: JobQuoteValidUntilModalProps) {
  return (
    <Modal open={open} title={`Quote job ${jobNumber}`} onCancel={onCancel} footer={null} destroyOnHidden>
      <Form<QuoteValidUntilFormValues>
        layout="vertical"
        requiredMark={false}
        initialValues={{ validUntil: dayjs().add(30, 'day') }}
        onFinish={(values) => onSubmit(values.validUntil.format('YYYY-MM-DD'))}
        disabled={submitting}
      >
        <Form.Item name="validUntil" label="Valid until" rules={[{ required: true, message: 'Pick the quote’s validity date' }]}>
          <DatePicker className="w-full" disabledDate={(day) => day.isBefore(dayjs(), 'day')} />
        </Form.Item>
        <Form.Item className="mb-0 flex justify-end">
          <Button type="primary" htmlType="submit" loading={submitting}>
            Send quote
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
